<ion-card
  class="ion-no-margin"
  (click)="routeTo(data)"
  class="{{ cityFlag ? 'cityCard' : '' }}"
>
  <ion-chip
    *ngIf="data.offerTag"
    class="{{
      cityFlag
        ? 'city-specific-disco-chip fs-1 font500 ion-text-center'
        : 'disco-chip'
    }} tertiary-chip"
  >
    {{ data.offerTag }}
  </ion-chip>

  <img
    [src]="data?.carousel_img || data?.image || placeholder"
    class="{{ data.exhausted ? 'greyscale' : '' }}"
  />
  <div class="text-overlay" *ngIf="data.title">
    <ion-card-title class="font14 font600 card-white-text-color">
      {{ data.title }}
    </ion-card-title>
  </div>
  <div [ngClass]="data?.locked ? 'locked-card' : ''">
    <img src="assets/icons/Lock.svg" />
  </div>
</ion-card>
